/*
 date-range is wrapper for Pikaday date selectors.

 'kareo.ui.shared.directives.date-range' is a filter-group

 If you use pikaday outside of the filter-group context, please extend this directive and style group in ui-kit to include your selector.

 Don't forget to include moment before pikaday in your build.config.js:

 ```
 js: [
 "third-party/moment/moment.js",
 "third-party/pikaday/pikaday.js",
 "third-party/pikaday-angular/pikaday-angular.js"
 ],
 css: [
 "third-party/pikaday/css/pikaday.css"
 ]
 ```

 You would add the directive to a collection of other filter-groups

 dateRange {
 startMoment: moment(),
 endMoment: moment()
 }

 ```
 .page-filters.grid-12
 .filter-group
 .grid-12.pbs
 | By Posting Date
 date-range-selector(date-range="dateRange", show-selection-shortcuts="true", selected-period="1 M", date-changed-callback="dateChangedCallback")
 ```
 */
angular.module('kareo.ui.shared.directives.date-range', ['pikaday'])
  .config([
    'pikadayConfigProvider', function (pikaday) {
      pikaday.setConfig({
        // minDate: moment().subtract(1, 'y').toDate(),
        // defaultDate: moment().subtract(1, 'M').toDate(),
        // setDefaultDate: true,
        maxDate: moment().toDate(), format: 'MMM D, YYYY'
      });
    }])
  .controller('DateRangeSelectorCtrl', [
    '$scope', function ($scope) {
      var initialized = false;
      $scope.$watch('dateRange', (newValue, oldValue) => {
        if (newValue && !initialized) {
          initialized = true;
          init();
        }
      });

      function init() {
        var format = 'MMM D, YYYY';
        // on pikaday load, set default dates. angular-pikaday only accepts strings right now. we could also modify the library to accept moment objects.
        $scope.$watch('startDatePicker', (newValue, oldValue) => {
          if ($scope.startDatePicker) {
            $scope.dateRange.startMoment = $scope.selectedPeriod ? moment().subtract(...$scope.selectedPeriod.split(' ')) : $scope.dateRange.startMoment;
            $scope.startDatePicker.setMoment($scope.dateRange.startMoment);
          }
        });
        $scope.$watch('endDatePicker', (newValue, oldValue) => {
          if ($scope.endDatePicker) {
            $scope.dateRange.endMoment = $scope.selectedPeriod ? moment() : $scope.dateRange.endMoment;
            $scope.endDatePicker.setMoment($scope.selectedPeriod ? moment() : $scope.dateRange.endMoment);
          }
        });
        $scope.dateRangeSelected = {
          period: $scope.selectedPeriod,
          startDate: ($scope.dateRange.startMoment || moment()).format(format),
          endDate: ($scope.dateRange.endMoment || moment()).format(format)
        };
        var updatePikadayDates = function (startMoment, endMoment) {
          $scope.startDatePicker.setMoment(startMoment);
          $scope.endDatePicker.setMoment(endMoment);
        };
        var updateSharedMoments = function () {
          $scope.dateRange.startMoment = $scope.startDatePicker.getMoment();
          $scope.dateRange.endMoment = $scope.endDatePicker.getMoment();
        };
        $scope.broadcastChanges = function () {
          updateSharedMoments();
          if ($scope.dateChangedCallback) {
            $scope.dateChangedCallback($scope.dateRange);
          }
        };
        $scope.selectPeriod = function (duration, period) {
          $scope.dateRangeSelected.period = duration + ' ' + period;
          var startDate = moment().subtract(duration, period);
          var endDate = moment();
          updatePikadayDates(startDate, endDate);
          $scope.broadcastChanges();
        };
        // Validation
        //   [config] Default date is today to today; Configured: enabled
        //   [config] Max date is today; Configured: enabled
        //   [config] Earliest date is a year ago; Configured: disabled
        //   [this] End date is greater then start date, correct end date and start date to user selected date
        $scope.validateStartDate = function (startDate) {
          if (startDate < $scope.endDatePicker.getMoment()) {
            updatePikadayDates(startDate, startDate);
          }
          $scope.dateRangeSelected.period = undefined;
        };
        $scope.validateEndDate = function (endDate) {
          if (endDate > $scope.startDatePicker.getMoment()) {
            updatePikadayDates(endDate, endDate);
          }
          $scope.dateRangeSelected.period = undefined;
        };
      }
    }])
  .directive('dateRangeSelector', [
    function () {
      return {
        restrict: 'E', replace: true, scope: {
          dateRange: '=', // { startMoment: moment(), endMoment: moment() }
          showSelectionShortcuts: '=?', // true | false
          selectedPeriod: '@', // '1 M' (moment time format)
          dateChangedCallback: '=?'
        }, controller: 'DateRangeSelectorCtrl', template: require('./date-range.pug')()
      };
    }]);
